import { env } from "@/env"

/**
 * 从 cookie 中获取指定 token
 * @param key token的cookie键，默认读取 NEXT_PUBLIC_AUTH_TOKEN_KEY
 */
export const getTokenFromCookie = (key?: string): string => {
	try {
		if (typeof document !== "undefined") {
			const cookieKey = key || env.NEXT_PUBLIC_AUTH_TOKEN_KEY
			if (!cookieKey) {
				console.warn("未配置cookie key（NEXT_PUBLIC_AUTH_TOKEN_KEY）")
				return ""
			}
			const match = document.cookie.match(new RegExp("(^| )" + cookieKey + "=([^;]+)"))
			return match ? decodeURIComponent(match[2]) : ""
		}
	} catch (err) {
		console.error("获取 cookie token 时异常：", err)
	}
	return ""
}
